// see https://router.vuejs.org/guide/#html

import e404 from './pages/404.vue'
import manageProfile from './pages/manageProfile.vue'
import editProfile from './pages/editProfile.vue'
import editUser from './pages/editUser.vue'
import listUsers from './pages/listUsers.vue'
import manageUser from './pages/manageUser.vue'
import listFiles from './pages/listFiles.vue'
import Login from './pages/login.vue'
import ForgotPassword from './pages/forgotPassword.vue'
import ResetPassword from './pages/resetPassword.vue'

import Roles from './models/Roles.js'

export default [
  {path: '/login', name: 'login', component: Login, meta: {public: true}},
  {path: '/forgotPassword', name: 'forgotPassword', component: ForgotPassword, meta: {public: true}},
  {path: '/admins', name: 'adminList', component: listUsers, props: {pageMode: 'admin'}, meta: {restricted: [Roles.superAdmin]}},
  {path: '/admins/new', name: 'adminCreate', component: editUser, props: {pageMode: 'admin'}, meta: {restricted: [Roles.superAdmin]}},
  {path: '/admins/:id', name: 'adminEdit', component: editUser, props: {pageMode: 'admin'}, meta: {restricted: [Roles.superAdmin]}},
  {path: '/admins/manage/:id', name: 'adminManage', component: manageUser, props: {pageMode: 'admin'}, meta: {restricted: [Roles.superAdmin]}},
  {path: '/clients', name: 'clientList', component: listUsers, props: {pageMode: 'client'}, meta: {restricted: [Roles.superAdmin, Roles.admin]}},
  {path: '/clients/new', name: 'clientCreate', component: editUser, props: {pageMode: 'client'}, meta: {restricted: [Roles.superAdmin, Roles.admin]}},
  {path: '/clients/:id', name: 'clientEdit', component: editUser, props: {pageMode: 'client'}, meta: {restricted: [Roles.superAdmin, Roles.admin]}},
  {path: '/clients/manage/:id', name: 'clientManage', component: manageUser, props: {pageMode: 'client'}, meta: {restricted: [Roles.superAdmin, Roles.admin]}},
  {path: '/profile', name: 'profileManage', component: manageProfile},
  {path: '/profile/edit', name: 'profileEdit', component: editProfile},
  {path: '/resetPassword/:token', name: 'resetPassword', component: ResetPassword, meta: {public: true}},
  {path: '/files/shared', name: 'sharedFiles', component: listFiles, props: {pageMode: 'shared'}},
  {path: '/files/mine', name: 'myFiles', component: listFiles, props: {pageMode: 'mine'}},
  {path: '*', component: e404, meta: {public: true}}
]



// WEBPACK FOOTER //
// ./src/routes.js